import { initializeState } from '../../../utilities/storageUtils';
import birthdayPartyActionTypes from './birthdayParty.types';

const INITIAL_STATE = {
  isLoadingBirthdayAvailabilityData: false,
  birthdayAvailabilityData: null,
  birthdayAvailabilityDataError: false,
  partyDate: null,
  partyGuestsCount: 10,
  partyTime: null,
  partyAdults: 2,
  partyKids: 8,
  partyInfants: null,
  partySpectators: null,
  numberOfExtraGuests: null,
  selectedParty: null,
  isDatePickerOpen: false,
  guestsOfHonor: []
};

const birthdayPartyReducer = (state, action) => {
  state = initializeState(state, INITIAL_STATE);

  // Get Book information reducers
  switch (action.type) {
    case birthdayPartyActionTypes.FETCH_PARTY_BOOKING_WIDGET_SEARCH_DATA:
      return {
        ...state,
        isLoadingBirthdayAvailabilityData: true
      };
    case birthdayPartyActionTypes.FETCH_PARTY_BOOKING_WIDGET_SEARCH_DATA_SUCCESS:
      return {
        ...state,
        isLoadingBirthdayAvailabilityData: false,
        birthdayAvailabilityData: action.birthdayAvailabilityData,
        birthdayAvailabilityDataError: false
      };
    case birthdayPartyActionTypes.FETCH_PARTY_BOOKING_WIDGET_SEARCH_DATA_ERROR:
      return {
        ...state,
        isLoadingBirthdayAvailabilityData: false,
        birthdayAvailabilityDataError: action.birthdayAvailabilityDataError,
        birthdayAvailabilityData: null,
        partyDate: null,
        partyGuestsCount: 10,
        partyTime: null,
        partyAdults: 2,
        partyKids: 8,
        partyInfants: null,
        partySpectators: null,
        numberOfExtraGuests: null,
        selectedParty: null,
        isDatePickerOpen: false,
        guestsOfHonor: []
      };

    case birthdayPartyActionTypes.CLEAR_PARTY_BOOKING_WIDGET_SEARCH_DATA_ERROR:
      return {
        ...state,
        birthdayAvailabilityDataError: false
      };

    case birthdayPartyActionTypes.SET_PARTY_BOOKING_WIDGET_FORM_SEARCH_DATA:
      return {
        ...state,
        partyDate: action.partyDate,
        partyGuestsCount: action.partyGuestsCount,
        partyTime: action.partyTime,
        partyAdults: action.partyAdults,
        partyKids: action.partyKids,
        partyInfants: action.partyInfants,
        partySpectators: action.partySpectators,
        ...(!isNaN(action.numberOfExtraGuests) && { numberOfExtraGuests: action.numberOfExtraGuests })
      };

    case birthdayPartyActionTypes.SET_SELECTED_BIRTHDAY_PARTY:
      return {
        ...state,
        selectedParty: action.selectedParty
      };

    case birthdayPartyActionTypes.TOGGLE_BIRTHDAY_PARTY_DATE_PICKER:
      return {
        ...state,
        isDatePickerOpen: action.isDatePickerOpen
      };
    case birthdayPartyActionTypes.CLEAR_PARTY_BOOKING_RESERVATION:
      return {
        ...state,
        ...INITIAL_STATE
      };
    case birthdayPartyActionTypes.SET_GUEST_OF_HONOR:
      return {
        ...state,
        guestsOfHonor: action.guestsOfHonor
      };
    case birthdayPartyActionTypes.CLEAR_PARTY_DATE:
      return {
        ...state,
        partyDate: null
      };
    case birthdayPartyActionTypes.CLEAR_PARTY_GUEST_OF_HONOR:
      return {
        ...state,
        guestsOfHonor: []
      };
    default:
      return state;
  }
};

export default birthdayPartyReducer;
